<div class="filtro-container">
  <div class="busqueda">
    <i class="pi pi-search"></i>

    <input
      type="text"
      placeholder="Buscar por nombre o código de medicamento..."
      (input)="buscar($event)"
    />
  </div>

  <p-dropdown
    [options]="filtros"
    optionLabel="label"
    optionValue="value"
    placeholder="Todos los medicamentos"
    class="filtro-dropdown"
    (onChange)="cambiarFiltro($event.value)"
  ></p-dropdown>
</div>
